import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiDepositList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDepositDetail = async (id) => {

  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDepositTransactionsList = async (depositId, filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/${depositId}/transactions/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDepositEntriesList = async (depositId, filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/${depositId}/entries/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDepositSellersSummary = async (depositId, filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/${depositId}/summary/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDepositsDownload = async (format, filters) => {
  try {
    const acceptHeader =
      format === 'csv'
        ? 'text/csv'
        : 'application/vnd.ms-excel';

    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/report/`, filters),
      {
        method: 'GET',
        headers: {
          ...buildHeaders(),
          Accept: acceptHeader,
        },
      }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

export const apiDepositTransactionsDownload = async (format, depositId, filters) => {
  try {
    const acceptHeader =
      format === 'csv'
        ? 'text/csv'
        : 'application/vnd.ms-excel';

    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/deposits/${depositId}/transactions/report/`, filters),
      {
        method: 'GET',
        headers: {
          ...buildHeaders(),
          Accept: acceptHeader,
        },
      }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};